import styled from '@emotion/styled';
import { alpha, Typography } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const DropzoneContainer = styled.div`
  min-height: 10rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: ${p => alpha(p.theme.palette.primary.main, 0.05)};
  border: 1px dashed ${p => p.theme.palette.divider};
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    border-color: ${p => p.theme.palette.primary.main};
  }
`;

export const DropzonePlaceholder = styled(Typography)`
  color: ${p => p.theme.palette.primary.main};
`;

export const DropzoneHelperText = styled(Typography)`
  color: ${p => p.theme.palette.text.secondary};
`;

DropzoneHelperText.defaultProps = {
  variant: 'caption',
};

export const MediaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const MediaItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const MediaItemDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const MediaItemFilename = styled(Typography)``;

export const MediaItemSize = styled(Typography)``;

MediaItemSize.defaultProps = {
  variant: 'caption',
  color: 'textSecondary',
};

export const MediaItemsPreview = styled.img`
  --size: 3rem;

  width: var(--size);
  height: var(--size);
  object-fit: cover;
  border-radius: 0.25rem;
`;
